import { useContext } from 'react';
import Context from './context';

const useSession = () => useContext(Context);

export default useSession;
